module.exports = __webpack_public_path__ + "media/images/application/template/flag-at-84661e3ae154697f7d95fabcaa213f5a.png";